import axios from './config';

const API_BASE_URL = '/contractors';

const getContractors = async (params = {}) => {
    try {
        const response = await axios.get(API_BASE_URL, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching contractors:', error);
        throw error;
    }
};

const getContractor = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching contractor:', error);
        throw error;
    }
};

const createContractor = async (data) => {
    try {
        const response = await axios.post(API_BASE_URL, data);
        return response.data;
    } catch (error) {
        console.error('Error creating contractor:', error);
        throw error;
    }
};

const updateContractor = async (id, data) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating contractor:', error);
        throw error;
    }
};

const deleteContractor = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting contractor:', error);
        throw error;
    }
};

export default {
    getContractors,
    getContractor,
    createContractor,
    updateContractor,
    deleteContractor
};
